import React from 'react';
import {useStyles} from "./BillingPeriodClosureRow.style";
import clsx from "clsx";
import BillingPeriodClosureRowProperties from "./BillingPeriodClosureRowProperties";
import ShowPrice from "../../../shared_components/Info/ShowPrice/ShowPrice";
import ShowSellerBasicInfo from '../../../shared_components/Info/ShowSellerBasicInfo/ShowSellerBasicInfo';
import ExpandoMenu from '../../../ui_components/ExpandoMenu/ExpandoMenu';
import DownloadSummarizedAgencyOrdersReportButton from '../../../shared_components/Buttons/DownloadSummarizedAgencyOrdersReportButton/DownloadSummarizedAgencyOrdersReportButton';
import DownloadAgencyOrdersReportButton from '../../../shared_components/Buttons/DownloadAgencyOrdersReportButton/DownloadAgencyOrdersReportButton';
import ButtonType from '../../../ui_components/Button/ButtonType';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import UpdateAgencyBillingClosureValuesButton from '../../../shared_components/Buttons/UpdateAgencyBillingClosureValuesButton/UpdateAgencyBillingClosureValuesButton';
import BillingPeriodStatus from '../../../entities/BillingPeriodStatus';

const BillingPeriodClosureRowMedium: React.FC<BillingPeriodClosureRowProperties> = ({
                                                            closure,
                                                            billingPeriodStatus,
                                                            billingPeriodStart,
                                                            billingPeriodEnd,
                                                            onUpdate = () => {
                                                            }
                                                        }) => {

    const classes = useStyles();

    return (
        <div className={clsx(classes.closure_row_container)}>
            <div className={classes.agency_cell}>
                <ShowSellerBasicInfo autofill name={closure.agencyName}/>
            </div>
            <div className={classes.amount_cell}>
                <ShowPrice value={closure.totalAmount}/>
            </div>
            <div className={classes.notes_cell}>
                {closure.notes || '-'}
            </div>
            <div className={classes.action_btns}>
                {billingPeriodStatus === BillingPeriodStatus.CLOSED && <UpdateAgencyBillingClosureValuesButton
                    agencyBillingClosureId={closure.id}
                    totalAmount={closure.totalAmount}
                    notes={closure.notes}
                    size={ButtonSize.DEFAULT}
                    type={ButtonType.SECONDARY}
                    showText={false}
                    onSave={onUpdate}
                />}
                <ExpandoMenu>
                    <>
                        <DownloadSummarizedAgencyOrdersReportButton
                            type={ButtonType.SECONDARY}
                            showPreview={true}
                            agencyId={closure.agencyId}
                            from={billingPeriodStart}
                            to={billingPeriodEnd}
                            size={ButtonSize.SMALL}
                        />
                        <DownloadAgencyOrdersReportButton
                            type={ButtonType.SECONDARY}
                            showPreview={true}
                            agencyId={closure.agencyId}
                            from={billingPeriodStart}
                            to={billingPeriodEnd}
                            size={ButtonSize.SMALL}
                        />
                    </>
                </ExpandoMenu>
            </div>
        </div>
    )
}

export default BillingPeriodClosureRowMedium;
